document.addEventListener("DOMContentLoaded", function (){
    (function (window){
            if (!window.customElements.get("yg-video-swiper")) {
                window.customElements.define("yg-video-swiper", YGVideoSwiper);
              }
            if (!window.customElements.get("yg-preview-swiper")){
                window.customElements.define("yg-preview-swiper", YGPreviewSwiper);
            } 
            if (!window.customElements.get("yg-logo-swiper")){
                window.customElements.define("yg-logo-swiper", YGLogoSwiper);
            }  
            if (!window.customElements.get("yg-reviews")){
                window.customElements.define("yg-reviews", YGReviews);
            } 
            if (!window.customElements.get("yg-swiper-style1")){
                window.customElements.define("yg-swiper-style1", YGSwiperStyle1);
            } 
            if (!window.customElements.get("yg-banner-swiper")){
                window.customElements.define("yg-banner-swiper", YGBannerSwiper);
            } 
    }(window))
})

// YG Video Swiper
var YGVideoSwiper = class extends HTMLElement {
    constructor() {
        super();
        this.loadScript();
    }

    loadScript(event) {
            let loadScript = document.createElement("script");
            loadScript.src = this.getAttribute("data-load-script");
            document.body.appendChild(loadScript);
            

            loadScript.onload = () => {
                this.swiper()
            }
    }

    swiper(){
        if(!this.querySelector(".yg-video-swiper")){
            return
        }
        let videoList = this.querySelectorAll("video")

        let newswiper = new Swiper(".yg-video-swiper", {
            slidesPerView: "auto",
            spaceBetween: 30,
            loop: true,
            centeredSlides: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            breakpoints: { 
               //当swiper宽度大于等于1150
              1150:{
                   slidesPerView:"auto",
                  spaceBetween:30
              },
                768: { 
                  slidesPerView: 1.4,
                  spaceBetween: 30
                },
                300: {
                  slidesPerView: 1,
                  spaceBetween: 20
                }
              },
              on:{
                slideChangeTransitionEnd: function(){
                  let activeIndex = this.activeIndex
                  if(videoList){
                      videoList.forEach(function (video, index){
                        if(index == activeIndex){
                            video.play()
                        } else {
                            video.pause()
                        }
                      })
                    }
                }
              }, 
        });
    }

};
// END YG Video Swiper

// YG Preview Swiper
var YGPreviewSwiper = class extends HTMLElement {
    constructor() {
        super();
        this.loadScript();
    }

    loadScript(event) {
        let loadScript = document.createElement("script");
        loadScript.src = this.getAttribute("data-load-script");
        document.body.appendChild(loadScript);
        

        loadScript.onload = () => {
            this.swiper()
        }
    }
    swiper(){
        let YGPreviewList = this.querySelector('.yg-preview-list')
        let YGVideoList = this.querySelector('.yg-video-list')
        let videoList = YGVideoList.querySelectorAll("video")
        if(!YGPreviewList && !YGVideoList) return
        let swiperPreview = new Swiper(YGPreviewList, {
            slidesPerView: 4,
            spaceBetween: 40,
            slideToClickedSlide: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 20
                },
                //当swiper宽度大于等于768
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                200: {
                    slidesPerView: 2,
                    spaceBetween: 10
                }
            },
        });
        new Swiper(YGVideoList, {
            slidesPerView: 1,
            spaceBetween: 10,
            effect: "fade",
            thumbs: {
              swiper: swiperPreview,
            },
            on:{
                slideChangeTransitionEnd: function(){
                  let activeIndex = this.activeIndex
                  if(videoList){
                      videoList.forEach(function (video, index){
                        console.log(index , activeIndex)
                        if(index == activeIndex){
                            video.play()
                        } else {
                            video.pause()
                        }
                      })
                    }
                },
            }
        });
    }
}
// END YG Preview Swiper

// YG Logo Swiper
var YGLogoSwiper = class extends HTMLElement {
    constructor() {
        super();
        this.loadScript();
    }
    loadScript(event) {
        let loadScript = document.createElement("script");
        loadScript.src = this.getAttribute("data-load-script");
        document.body.appendChild(loadScript);
        

        loadScript.onload = () => {
            this.swiper()
        }
    }
    swiper(){
        if(!this.querySelector(".yg-logo-swiper")){
            return
        }

        let YGLogoList = this.querySelector('.yg-logo-list')
        let YGTextList = this.querySelector('.yg-text-list')
        let swiperLogo = new Swiper(YGLogoList, {
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 20
                },
                //当swiper宽度大于等于768
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                550: {
                    slidesPerView: 2,
                    spaceBetween: 10
                }
            },
        });
        new Swiper(YGTextList, {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
              swiper: swiperLogo,
            },
        });
    }
}
// END YG Logo Swiper

// YG Reviews
var YGReviews = class extends HTMLElement {
    constructor() {
        super();
        this.loadScript();
    }
    loadScript(event) {
        let loadScript = document.createElement("script");
        loadScript.src = this.getAttribute("data-load-script");
        document.body.appendChild(loadScript);
        
        loadScript.onload = () => {
            this.swiper()
        }

        this.openPlayDialog()
        this.closePlayDialog()
    }
    swiper(){
        if(!this.querySelector(".yg-blocks")){
            return
        }
        new Swiper(".yg-blocks", {
            autoHeight: true,
            slidesPerView: 1.1,
            spaceBetween: 12,
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar"
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                767: {
                    slidesPerView: 1.5,
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                1440: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                }
            }
        });
    }
    openPlayDialog() {
        let btnlist = this.querySelectorAll(".yg-video-media-open-btn")
        btnlist.forEach((btn) => {
            btn.addEventListener("click", ()=>{
                console.log(btnlist,btn)
                const block_id = btn.getAttribute('data-id')
                const video_type = btn.getAttribute('data-video-type')
                const dialog = this.querySelector(".yg-video-media-dialog")
                const dialog_content = this.querySelector(`#yg-video-media-dialog-content-${block_id}`).content.cloneNode(true)
                const close_btn = this.querySelector(".yg-video-media-close-btn")
                dialog.style.display = "block"
                dialog.appendChild(dialog_content)
                
                if(video_type != "video") {
                    const {width: x,height: y} = dialog.querySelector('.yg-video').getBoundingClientRect()
                    close_btn.style.marginTop = - y / 2 - 18 + "px"
                    close_btn.style.marginLeft = x / 2 + "px"
                } else {
                    dialog.querySelector('.yg-video').addEventListener('loadedmetadata', function() {
                        // 解决offsetWidth有时候会获取不到视频的实际渲染高度的问题
                        let {videoWidth: x, videoHeight: y, offsetWidth: w, offsetHeight: h} = dialog.querySelector('.yg-video')
                        if(window.isMobile) {
                            h = y * w / x
                        } else {
                            w = x * h / y
                        }
                        close_btn.style.marginTop = - h / 2 - 18 + "px"
                        close_btn.style.marginLeft = w / 2 + "px"
                    });
                }
            })
        })
    }
    closePlayDialog() {
        this.querySelector(".yg-video-media-close-btn").addEventListener("click", () => {
            const dialog = this.querySelector(".yg-video-media-dialog")
            dialog.style.display = "none"
            dialog.removeChild(dialog.lastElementChild)
        })
    }
}
// END YG Reviews

// YG Video Reviews
var YGSwiperStyle1 = class extends HTMLElement {
    constructor() {
        super();
        this.loadScript();
    }

    loadScript(event) {
        let loadScript = document.createElement("script");
        loadScript.src = this.getAttribute("data-load-script");
        document.body.appendChild(loadScript);
        
        loadScript.onload = () => {
            this.swiper()
        }
    }

    swiper(){
        let swiperItem = this.querySelector('.swiper.swiper-style1')
        console.log(swiperItem)
        if(!swiperItem) return

        let swiperItemCount = swiperItem.getAttribute("data-item-count") ? swiperItem.getAttribute("data-item-count") : 4
        let swiperItemGap = swiperItem.getAttribute("data-item-gap") ? swiperItem.getAttribute("data-item-gap") : 24
        
        new Swiper(swiperItem, {
            slidesPerView: 1.2,
            spaceBetween: 15,
            breakpoints: {
              //当宽度大于等于768
              768: {
                slidesPerView: swiperItemCount * 0.8,
                spaceBetween: swiperItemGap * 0.8
              },
              //当宽度大于等于1280
              1280: {
                slidesPerView: swiperItemCount,
                spaceBetween: swiperItemGap
              },
              //当宽度大于等于1680
              1680: {
                slidesPerView: swiperItemCount * 1.1,
                spaceBetween: swiperItemGap * 1.1
              }
            },
            scrollbar: {
              el: ".swiper-scrollbar",
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }
        })
    }
}

// YG Banner Swiper

var YGBannerSwiper = class extends HTMLElement {
    constructor() {
        super();
        this.loadScript();
    }

    loadScript(event) {
        let loadScript = document.createElement("script");
        loadScript.src = this.getAttribute("data-load-script");
        document.body.appendChild(loadScript);
        
        loadScript.onload = () => {
            this.swiper()
        }
    }
    swiper(){
        let swiperTextItem = this.querySelector('.yg-banner-swiper-text')
        let swiperContainerItem = this.querySelector('.yg-banner-swiper-container')

        console.log()
        if(!swiperTextItem || !swiperContainerItem) return

        let swiperText = new Swiper(swiperTextItem, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            grabCursor: true,
            effect: "creative",
            creativeEffect: {
                prev: {
                    shadow: true,
                    translate: [0, 0, 0],
                    opacity: 0
                },
                next: {
                    translate: [0, "100%", 0],
                    opacity: 0
                },
            },

        });
        new Swiper(swiperContainerItem, {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            centeredSlides: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            autoplay: {
                delay: 5000,
                stopOnLastSlide: false,
                disableOnInteraction: false,
            },
            breakpoints: {
                //当swiper宽度大于等于768
                768: {
                    slidesPerView: 1,
                    spaceBetween: 30
                },
                300: {
                    slidesPerView: 1,
                    spaceBetween: 0
                }
            },
            controller: {
                control: swiperText,
            }
        });
    }
}

// END YG Video Reviews